export default __webpack_public_path__ + "static/media/fad-midiplug.63bc2e41.svg";